import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';

import './SignUp.scss';
import Modal from '../../shared/Modal';
import FormPupLogo from '../../../images/form-pup-text-logo.png';
import { authCodesMap } from '../authCodesMap';

function SignUp(props) {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const signUp = async (e) => {
    e.preventDefault();

    try {
      const auth = getAuth();
      await createUserWithEmailAndPassword(auth, email, password);
      history.push('/');
    } catch (e) {
      const errorMessage = authCodesMap[e.code] || 'An error occurred creating your account. Please try again.';
      setModalTitle('Error:');
      setModalText(errorMessage);
    }
  };

  return (
    <div className="SignUp">
      <div className="form-container">
        <div className="well auth-well">
          <div className="logo-container">
            <img
              src={FormPupLogo}
              alt="Form Pup Logo"
              className="logo"
            />
          </div>

          <h1>Get Started Today</h1>

          <form onSubmit={signUp}>
            <div className="input-container">
              <label>Email:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email"
              />
            </div>

            <div className="input-container">
              <label>Password:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />
            </div>

            <button
              type="submit"
            >
              Sign Up
            </button>
          </form>

          <div className="sign-in-container">
            <span>Already have an account? </span>

            <Link to="/signin">
              Sign In
            </Link>
          </div>

          <div className="terms-container">
            <p>
              <span>* By signing up, you agree to our </span>
              <a href="https://formpup.com/terms-conditions/">
                Terms of Use
              </a>
              <span> & </span>
              <a href="https://formpup.com/privacy-policy/">
                Privacy Policy
              </a>
            </p>
          </div>

          <div className="copyright-container">
            <p>Copyright © {new Date().getFullYear()}, Form Pup LLC - All Rights Reserved</p>
          </div>
        </div>
      </div>

      <Modal
        open={!!modalText}
        close={() => {
          setModalTitle('');
          setModalText('');
        }}
        title={modalTitle}
        buttons={[
          <button key="modal-close" className="small" onClick={() => {
            setModalTitle('');
            setModalText('');
          }}>Close</button>,
        ]}
      >
        <div>
          <div className="modal-text">{modalText}</div>
        </div>
      </Modal>
    </div>
  );
}

export default SignUp;
